module.exports = __webpack_public_path__ + "media/images/logo-b435eb6c5fb331409eaff21bd76e76ac.svg";